import { styled } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';

const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  minWidth: '320px',
});

export default StyledDialogContent;
